import React from 'react';
import Header from "../../../../components/Headers/BasicHeader";
import '../Index.css'
import Paginations from '../../../../components/Pagination/BasicPagination';
import { useNavigate } from "react-router-dom";

import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    Table,
    Form,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup,
    Button,
    Spinner
} from "reactstrap";
import { getInstallationTypes, deleteInstallationType } from "../../../../network/ApiAxios";
import ConfirmModal from 'components/Modals/ConfirmModal';

import { useTableData } from '../../../../hooks/useTableData';

const InstallationTypes = () => {


    const {
        data: installationTypes,
        dataBackup: installationTypeBackup,
        showModal,
        modalMessage,
        modalTitle,
        modalResult,
        loadingId,
        isLoading,
        foundRegisters,
        currentPage,
        itemsPerPage,
        searchKey,
        sortField,
        sortDirection,
        setShowModal,
        setModalResult,
        setCurrentPage,
        handleSort,
        handleSearch,
        handleDelete
    } = useTableData({
        fetchFunction: getInstallationTypes,
        deleteFunction: deleteInstallationType,
        params: {},
        searchFields: ['name', 'detail'],
        dataKey: 'installationTypes'
    });

    const navigate = useNavigate();

    return (
        <>
            <Header></Header>

            <Container>
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <CardHeader className="border-0 pb-3 pt-3 pt-md-3">

                                <Row id="headerOptions" className=''>

                                    <Col lg="8" md="8">
                                        <Form className="navbar-search-light form-inline mr-3 d-none d-md-flex  w-100   ">
                                            <FormGroup className="mb-0 w-100 ">
                                                <InputGroup id="search-input" className="input-group-alternative w-100 ">

                                                    <InputGroupAddon addonType="prepend" className='w-100'>
                                                        <InputGroupText >
                                                            <i className="fas fa-search" />
                                                        </InputGroupText>
                                                        <Input value={searchKey} onChange={handleSearch} className='w-100' placeholder="Search" type="text" />
                                                    </InputGroupAddon>

                                                </InputGroup>
                                            </FormGroup>
                                        </Form>
                                    </Col>
                                    <Col id='addButton' lg="4" md="4">
                                        <Button onClick={() => navigate('/admin/installationTypes/create')}
                                            className="btn-icon btn-3" color="primary" type="button">

                                            <span className="btn-inner--text">Create an installation type</span>

                                            <span className="btn-inner--icon">
                                                <i className="ni ni-fat-add" />
                                            </span>

                                        </Button>
                                    </Col>
                                        
                                    
                                </Row>
                            </CardHeader>

                            {isLoading && !loadingId ? (
                                <div className="text-center p-5">
                                    <Spinner size="lg"/>
                                </div>

                            ) : (

                                <Table className="align-items-center table-flush" responsive>
                                    <thead >
                                        <tr>
                                            <th scope="col" 
                                                onClick={() => handleSort('name')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'name' ? 'table-header-sorted' : ''}
                                            >
                                                Name
                    
                                                    <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />
                                                
                                    
                                            </th>
                                            <th scope="col" 
                                                onClick={() => handleSort('detail')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                className={sortField === 'detail' ? 'table-header-sorted' : ''}
                                            >
                                                Details
                    
                                                    <i className={`fas fa-arrow-${sortDirection === 'asc' ? 'down' : 'up'} ml-2`} />
                                                
                                    
                                            </th>                                            
                                            <th scope="col" className='text-right'>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {installationTypes.map(installationType => (
                                            <tr key={installationType._id}>
                                                <td scope="row">  {installationType.name} </td>
                                                <td>{installationType.detail}</td>
                                                <td className='text-right'>
                                                    <Button className="btn-icon action" color="success" type="button"
                                                        onClick={() => navigate('/admin/installationTypes/view/' + installationType._id)}
                                                        disabled={loadingId === installationType._id}
                                                    >

                                                        <span className="btn-inner--icon">
                                                            <img
                                                                id="view-button"
                                                                alt="view"
                                                                src={require("assets/img/icons/common/eye-button.svg").default}
                                                            />
                                                        </span>

                                                    </Button>

                                                    <Button className="btn-icon action" color="primary" type="button"
                                                        onClick={() => navigate('/admin/installationTypes/edit/' + installationType._id)}
                                                        disabled={installationType.isMaster || installationType.isOwner || loadingId === installationType._id}
                                                    >

                                                        <span className="btn-inner--icon">
                                                            <img

                                                                alt="edit"
                                                                src={require("assets/img/icons/common/edit-button.svg").default}
                                                            />
                                                        </span>

                                                    </Button>
                                                    <Button onClick={()=>handleDelete(installationType._id)} 
                                                        className="btn-icon action" color="warning" type="button"
                                                        disabled={installationType.isMaster || installationType.isOwner || loadingId === installationType._id}
                                                    >

                                                        {loadingId === installationType._id ? (
                                                            <Spinner size="sm" className="me-2 mx-1" />
                                                        
                                                        ) : (
                                                            <>
                                                            <span className="btn-inner--icon">
                                                                <img
                                                                    id="delete-button"
                                                                    alt="delete"
                                                                    src={require("assets/img/icons/common/delete-button.svg").default}
                                                                />
                                                            </span>
                                                            </>
                                                        )}

                                                    </Button>

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </Card>
                    </div>
                </Row>

                <Row className='pt-md-3'>
                    <Col>
                        <span className="h5 itens-quantity">
                            {installationTypeBackup?.length} Installation Types
                        </span>
                    </Col>
                    <Col>
                        <Paginations
                            itemsPerPage={itemsPerPage}
                            totalItems={foundRegisters}
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                        />                            
                        
                    </Col>
                </Row>

            </Container>

            <ConfirmModal
                title={modalTitle}
                message={modalMessage}
                showModal={showModal}
                setShowModal={setShowModal}
                setModalResult={setModalResult} />
        </>
    );
}

export default InstallationTypes;
